function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ChatManagerOverlayTemplate = require('./chat-manager.template');
var ChatManagerMenu = require('./chat-manager-menu');

//Floating Chat Manager for mobile
var ChatManagerOverlay = /*#__PURE__*/function () {
  function ChatManagerOverlay(app, mod) {
    var _this = this;
    _classCallCheck(this, ChatManagerOverlay);
    this.app = app;
    this.mod = mod;
    this.headerClickHandler = null;
    this.historyEntryActive = false;
    this.backFn = null;
    this.hasBackFn = false;
    this.isOpen = false;
    this.oldRenderManagerToScreen = 0;
    this.oldChatPopupContainer = '';
    this.chatManagerMenu = new ChatManagerMenu(app, mod, '.chat-manager-overlay-settings-content', false);
    app.connection.on('close-chat-manager-overlay', function () {
      var overlay = document.querySelector('.chat-manager-overlay');
      if (overlay) {
        overlay.style.visibility = 'hidden';
      }
      _this.isOpen = false;
      _this.historyEntryActive = false;
      _this.detachHeaderClose();
      if (_this.hasBackFn) {
        window.onpopstate = _this.backFn;
        _this.backFn = null;
        _this.hasBackFn = false;
      }
      if (_this.mod.chat_manager) {
        _this.mod.chat_manager.container = _this.old_container;
        _this.mod.chat_manager.chat_popup_container = _this.oldChatPopupContainer;
        _this.mod.chat_manager.render_manager_to_screen = _this.oldRenderManagerToScreen;
        if (_this.oldRenderManagerToScreen) {
          _this.app.connection.emit('chat-manager-render-request');
        }
      }
    });
  }
  return _createClass(ChatManagerOverlay, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var overlay, header, overlayTop;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!document.querySelector('.chat-manager-overlay')) {
                this.app.browser.addElementToDom(ChatManagerOverlayTemplate(this.app, this.mod));
              }
              overlay = document.querySelector('.chat-manager-overlay');
              overlay.style.visibility = 'visible';
              overlay.dataset.chatOverlayView = 'chats';
              this.setActiveAction('chats');
              header = document.getElementById('saito-header');
              overlayTop = header ? header.getBoundingClientRect().bottom : 0;
              overlay.style.setProperty('--chat-manager-overlay-top', "".concat(Math.max(0, overlayTop), "px"));
              if (this.mod.chat_manager == null) {
                this.mod.respondTo('chat-manager');
                this.mod.chat_manager.render_popups_to_screen = 0;
              }
              if (!this.isOpen) {
                this.old_container = this.mod.chat_manager.container;
                this.oldChatPopupContainer = this.mod.chat_manager.chat_popup_container;
                this.oldRenderManagerToScreen = this.mod.chat_manager.render_manager_to_screen;
              }
              this.isOpen = true;

              // Make sure we can render chat manager within the overlay
              this.mod.chat_manager.render_manager_to_screen = 1;
              this.mod.chat_manager.container = '.chat-manager-overlay-content';
              this.mod.chat_manager.chat_popup_container = '';
              this.app.connection.emit('chat-manager-render-request');
              this.attachEvents();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }() //
    // Note: mod = Arcade
    //
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      if (this.app.browser.isMobileBrowser() || window.innerWidth < 600) {
        if (!this.historyEntryActive) {
          window.history.pushState('chat-manager-overlay', '');
          this.historyEntryActive = true;
          this.backFn = window.onpopstate;
          this.hasBackFn = true;
          window.onpopstate = function (e) {
            _this2.historyEntryActive = false;
            _this2.app.connection.emit('close-chat-manager-overlay');
          };
        }
        document.querySelectorAll('.chat-manager-overlay .chat-manager-mobile-menu .item').forEach(function (item) {
          item.onclick = /*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
              var action;
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.n) {
                  case 0:
                    action = e.currentTarget.dataset.chatAction;
                    if (action === 'chats') {
                      _this2.showChats();
                    }
                    if (!(action === 'add-contact')) {
                      _context2.n = 1;
                      break;
                    }
                    _context2.n = 1;
                    return _this2.chatManagerMenu.addContact();
                  case 1:
                    if (!(action === 'new-group')) {
                      _context2.n = 2;
                      break;
                    }
                    _context2.n = 2;
                    return _this2.chatManagerMenu.createGroup();
                  case 2:
                    if (action === 'mark-read') {
                      _this2.chatManagerMenu.markAllRead();
                    }
                    if (!(action === 'settings')) {
                      _context2.n = 3;
                      break;
                    }
                    _context2.n = 3;
                    return _this2.showSettings();
                  case 3:
                    return _context2.a(2);
                }
              }, _callee2);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }();
        });
        setTimeout(function () {
          return _this2.attachHeaderClose();
        }, 0);
      } else {
        this.app.browser.makeDraggable('chat-manager-overlay', 'chat-manager-header');
        var cmo = document.getElementById('chat-manager-overlay');
        cmo.style.resize = 'vertical';
      }
    }
  }, {
    key: "attachHeaderClose",
    value: function attachHeaderClose() {
      var _this3 = this;
      var header = document.getElementById('saito-header');
      if (!header || this.headerClickHandler) {
        return;
      }
      this.headerClickHandler = function () {
        if (_this3.historyEntryActive) {
          window.history.back();
        } else {
          _this3.app.connection.emit('close-chat-manager-overlay');
        }
      };
      header.addEventListener('click', this.headerClickHandler);
    }
  }, {
    key: "detachHeaderClose",
    value: function detachHeaderClose() {
      var header = document.getElementById('saito-header');
      if (header && this.headerClickHandler) {
        header.removeEventListener('click', this.headerClickHandler);
      }
      this.headerClickHandler = null;
    }
  }, {
    key: "setActiveAction",
    value: function setActiveAction(action) {
      document.querySelectorAll('.chat-manager-overlay .chat-manager-mobile-menu .item').forEach(function (item) {
        item.classList.toggle('active', item.dataset.chatAction === action);
      });
    }
  }, {
    key: "showChats",
    value: function showChats() {
      var overlay = document.querySelector('.chat-manager-overlay');
      if (!overlay) {
        return;
      }
      overlay.dataset.chatOverlayView = 'chats';
      this.setActiveAction('chats');
      this.mod.chat_manager.container = '.chat-manager-overlay-content';
      this.app.connection.emit('chat-manager-render-request');
    }
  }, {
    key: "showSettings",
    value: function () {
      var _showSettings = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var overlay;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              overlay = document.querySelector('.chat-manager-overlay');
              if (overlay) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              overlay.dataset.chatOverlayView = 'settings';
              this.setActiveAction('settings');
              _context3.n = 2;
              return this.chatManagerMenu.render();
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function showSettings() {
        return _showSettings.apply(this, arguments);
      }
      return showSettings;
    }()
  }]);
}();
module.exports = ChatManagerOverlay;